const getLoggedInUserDetails = () => {
  const token = sessionStorage.getItem("adminToken") || null;

  const user = JSON.parse(sessionStorage.getItem("admin") || "null");

  return { token, user };
};
export default getLoggedInUserDetails;
